import {
  selectAvailableColors,
  selectCurrentFilterName,
  selectCurrentSubFilterIndex,
  selectFilterSelectedColor,
} from './productMenuSelectors';
import {
  actionSetSwiperSubFilter,
  actionSetColor,
  actionSetFilter,
} from './productMenuActions';
import { Dispatch } from 'redux';
import { GetState } from '../../generalTypes';
import { ColorCombination } from './productMenuTypes';

export const thunkSetFilter =
  (filterName: string) => (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const previousFilter = selectCurrentFilterName(state);
    const previousColor = selectFilterSelectedColor(state, previousFilter);
    dispatch(actionSetFilter(filterName));
    dispatch(actionSetSwiperSubFilter(selectCurrentSubFilterIndex(state)));
    // @ts-ignore
    dispatch(thunkSetDefaultColorFilter(filterName, previousColor));
  };

/**
 * Sets sub filter and updates swiper items
 *
 * @param subFilterIndex
 * @returns void
 */
export const thunkSetSubFilter =
  (subFilterIndex: number) => (dispatch: Dispatch, getState: GetState) => {
    dispatch(actionSetSwiperSubFilter(subFilterIndex));
  };

/**
 * Finds and sets default color filter
 *
 * @param filterName - which filter is being targeted
 * @param previousColor - If there were a previous color selected for perhaps a previous
 *                        filter and this color is available for this filter as well,
 *                        said color will be selected as default.
 */
const thunkSetDefaultColorFilter =
  (filterName: string, previousColor?: ColorCombination | undefined) =>
  (dispatch: any, getState: GetState) => {
    const availableColors = selectAvailableColors(getState());

    if (availableColors && Object.values(availableColors).length) {
      const previousColorIsValid =
        previousColor && availableColors.hasOwnProperty(previousColor.name);
      const [{ name: defaultColor }] = Object.values(availableColors);

      previousColorIsValid
        ? dispatch(actionSetColor(previousColor.name, filterName))
        : dispatch(actionSetColor(defaultColor, filterName));
    }
  };

/**
 * Sets color filter and updates swiper items
 * @param color
 * @returns void
 */
export const thunkSetColorFilter =
  (color: string) => (dispatch: Dispatch, getState: GetState) => {
    dispatch(actionSetColor(color, selectCurrentFilterName(getState())));
  };
